import { render, staticRenderFns } from "./PageSmsNotificationsSettings.vue?vue&type=template&id=81c83862&"
import script from "./PageSmsNotificationsSettings.vue?vue&type=script&lang=ts&"
export * from "./PageSmsNotificationsSettings.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports